import React from 'react';
import classNames from 'classnames';

import SectionLineTop from '../../img/section-line-top.webp';
import SectionLineBottom from '../../img/section-line-bottom.webp';
import LineYellow from '../../img/line-yellow.svg';
import Line from '../../img/line.svg';
import WinnerMan from '../../img/winner-man.webp';
import WinnerSticker from '../../img/winner-sticker.webp';
import Gems from '../../img/gems.webp';

import * as styles from './index.module.scss';

export const Loyalty = () => (
  <section className={styles.loyalty}>
    <div className={styles.lineTop}>
      <img src={SectionLineTop} alt="Section Line Top" />
    </div>
    <div className={styles.content}>
      <div className={styles.line}>
        <img src={Line} alt="Line" />
      </div>
      <div className="container">
        <div className={styles.wrap}>
          <h2 className={styles.head}>
            Вступай <span className="nowrap">в программу</span> лояльности
          </h2>

          <div className={styles.columns}>
            <div className={styles.column}>
              <div className={classNames(styles.card, styles.cardFreebet)}>
                <h3 className={styles.title}>Фрибеты каждую неделю</h3>
                <p className={styles.text}>
                  Играй активно и&nbsp;забирай бесплатную ставку каждый понедельник
                </p>
                <img src={LineYellow} className={styles.lineYellow} alt="Line Yellow" />
                <div className={styles.winner}>
                  <img src={WinnerMan} className={styles.winnerMan} alt="Winner Man" />
                  <img src={WinnerSticker} alt="Winner Sticker" className={styles.winnerSticker} />
                </div>
              </div>
            </div>
            <div className={styles.column}>
              <div className={classNames(styles.card, styles.cardGems)}>
                <h3 className={styles.title}>Выше уровень — выше сумма</h3>
                <p className={styles.text}>
                  Переходи на&nbsp;новые уровни программы лояльности, чтобы получать повышенные
                  фрибеты
                </p>
                <div className={styles.gems}>
                  <img src={Gems} alt="Gems" />
                </div>
              </div>
              <div className={styles.card}>
                <h3 className={styles.title}>Кешбэк в конце месяца</h3>
                <p className={styles.text}>
                  Возвращаем до&nbsp;50&nbsp;000&nbsp;₽ самым активным ежемесячно
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className={styles.lineBottom}>
      <img src={SectionLineBottom} alt="Section Line Top" />
    </div>
  </section>
);
